import { useState, useEffect, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";

import TestApp from "./Tests";
import { Modal, Box, Typography, Button, useMediaQuery, Stack } from "@mui/material";

import { schoolDistrictColorsID } from "../constants";
import withUser from "../wrappers/withUser";
import PlainModal from "./modals/PlainModal";
import CountdownTimer from "./utilities/CountdownTimer";
import { useGetExamComponentQuery, useGetExamComponentBaseQuery, usePostExamComponentMutation } from "../api";


const AnyTestComponent = ({userData}) => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const navigate = useNavigate();
  let { exam_component_id, exam_component_base_id } = useParams();

  const { data: exam_component_data, loading: exam_component_loading_data } = useGetExamComponentQuery(exam_component_id, null);
  const { data: exam_component_base_data, loading: exam_component_base_loading } = useGetExamComponentBaseQuery(exam_component_base_id, null);
  const { submit: submitExamComponent, data: examComponentPostData } = usePostExamComponentMutation();

  const [questonListExport, setQuestionListExport] = useState();

  const [leavePageWarningOpen, setLeavePageWarningOpen] = useState(false);
  const toggleLeavePageWarningOpen = () => {setLeavePageWarningOpen(!leavePageWarningOpen)};
  const [warningsRemaining, setWarningsRemaining] = useState(2);

  const handleSubtractWarning = async () => {
    await submitExamComponent({
      "subtract_warning" : {
        "exam_component_id": parseInt(exam_component_id)
      }
    })
  };

  useEffect(() => {
    if (!examComponentPostData?.data?.length) return;

    setWarningsRemaining(examComponentPostData.data[0].warnings_remaining);
  }, [examComponentPostData]);

  useEffect(() => {
  const handleVisibilityChange = () => {
    if (document.visibilityState === 'hidden') {
      toggleLeavePageWarningOpen();
      handleSubtractWarning();
    } else if (document.visibilityState === 'visible') {
    }
  };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  useEffect(() => {
    if (warningsRemaining <= 0) {
      navigate(`/exam-launchpad/${exam_component_base_id}`);
    }
  }, [warningsRemaining]);

  useEffect(() => {
    if (!exam_component_base_data) return;

    const questionList = []
    for (let i=1; i<exam_component_base_data.data[0].question_count+1; i++) {
      questionList.push("Question " + String(i));
    }

    setQuestionListExport(questionList);
  }, [exam_component_base_data])


  const AppBarStyle = {width:'100%', color:'white', bgcolor:schoolDistrictColorsID[userData[0].school_district]};
  const bigBoxStyle = {display:'flex',flexDirection:'column',width:'50vw', textAlign:'left'};
  const mobileBoxStyle = {display:'flex',flexDirection:'column',width:'94vw', textAlign:'left'};

  return (
    <Box>
      <Modal
        open={leavePageWarningOpen}
        onClose={toggleLeavePageWarningOpen}
      >
        <PlainModal 
          headerString={'DO NOT LEAVE THE EXAM PAGE'} 
          actionString={'Leaving the page is not permitted.  If this happens again, your exams may be automtically failed.'} 
          action={toggleLeavePageWarningOpen}
          handleClose={toggleLeavePageWarningOpen}
        />
      </Modal>

      <Box sx={{position:'fixed',width:'100%', zIndex:999}}>
        <Box sx={AppBarStyle}>
          <Box sx={{p:2, display:'flex', flexDirection:'row', justifyContent:'space-between', alignItems:'center'}}>
            {exam_component_base_data && (<Typography variant='h5' sx={{fontWeight:600}}>{exam_component_base_data.data[0].exam_component_title}</Typography>)}
            <Stack direction={'row'} gap={2} sx={{alignItems:'center'}}>
              {exam_component_data && (<CountdownTimer expiration={exam_component_data.data[0].expiration}/>)}
              <Button variant="outlined" onClick={() => navigate(`/exam-launchpad/${exam_component_base_id}`)} sx={{ color: 'white', borderColor: 'white'}}>Exit</Button>
            </Stack>
          </Box>
        </Box>
      </Box>

      <Box sx={{display:'flex',flexDirection:'column',alignItems:'center',pt:10, pr:2, pl:2}}>
        {exam_component_base_data && (
          <TestApp
            questionCount={exam_component_base_data.data[0].question_count}
            questionList={questonListExport}
            examComponentId={exam_component_id}
            examComponentBaseId={exam_component_base_id}
          />)
        }
      </Box>
    </Box>
  )
};

export default withUser(AnyTestComponent);